import { render, staticRenderFns } from "./GraphDetail10.vue?vue&type=template&id=160c54da&scoped=true"
import script from "./GraphDetail10.vue?vue&type=script&lang=js"
export * from "./GraphDetail10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c54da",
  null
  
)

export default component.exports